export default __webpack_public_path__ + "static/media/pin.39bf7cb8.svg";